import { useState } from 'react';
import { useNudgeStep } from '../hooks';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

interface NudgeButtonProps {
    checklistId: string;
    stepId: string;
    assigneeName: string;
}

export function NudgeButton({
    checklistId,
    stepId,
    assigneeName,
}: NudgeButtonProps) {
    const nudge = useNudgeStep(checklistId);
    const [nudged, setNudged] = useState(false);

    const handleNudge = (e: React.MouseEvent) => {
        e.preventDefault(); // prevent parent link navigation
        e.stopPropagation();

        if (nudged) {
            toast.info('Nudge already sent — wait before sending another');
            return;
        }

        nudge.mutate(
            { stepId },
            {
                onSuccess: () => {
                    setNudged(true);
                    toast.success(`Nudge sent to ${assigneeName}`);
                    // Allow re-nudge after 60 s
                    setTimeout(() => setNudged(false), 60_000);
                },
            }
        );
    };

    return (
        <Button
            variant="ghost"
            size="sm"
            className="h-7 px-2 text-xs"
            onClick={handleNudge}
            disabled={nudge.isPending || nudged}
            title={`Send reminder to ${assigneeName}`}
        >
            {nudged ? '✓ Nudged' : '👋 Nudge'}
        </Button>
    );
}